export default __webpack_public_path__ + "static/media/05.2fa32f05.png";